import axios from "axios";
import { useAuthStore } from "@/stores";
import { isEmpty as _isEmpty } from "lodash-es";

export default {
  createAxiosInstance() {
    const authStore = useAuthStore();

    let configs = {
      baseURL: process.env.VUE_APP_API_URL,
      headers: {
        Accept: "application/json",
        "Content-type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
      withCredentials: true,
    };

    if (!_isEmpty(authStore.$state.token)) {
      configs = Object.assign(configs, {
        Authorization: `Bearer ${authStore.$state.token}`,
      });
    }

    const instance = axios.create(configs);

    instance.interceptors.request.use(
      (config) => {
        // Get fresh dealer domain from localStorage (most reliable)
        const dealerDomain = localStorage.getItem('dealer_domain');

        if (dealerDomain) {
          config.headers['X-Dealer-Subdomain'] = dealerDomain;
        }

        // Also update auth header if token exists
        const token = localStorage.getItem('bearer_token');
        if (token) {
          config.headers.Authorization = `Bearer ${JSON.parse(token)}`;
        }

        return config;
      },
      (error) => {
        return Promise.reject(error);
      }
    );

    instance.interceptors.response.use(
      (response) => response,
      async (error) => {
        if (error.response?.status === 403 && error.response?.data?.error?.includes('dealer')) {

          // if dealer mismatched, refresh auth
          const authStore = useAuthStore();
          await authStore.getAuth();

        }
        return Promise.reject(error);
      }
    );

    return instance;

  },
};
